import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import { CostService, rgrnService } from "../../../services/index";
import * as fromRootStore from "../../../reducers";
import { ComboService, SampleService } from "../../../services/index";


@Component({
  selector: "AddeditBagging",
  templateUrl: "./AddeditBagging.html",
})
export class AddeditBagging {
  auto_number: number;
  season_name: string;
  row: any;
  data: any;
  temp: any = {
    set: '',
    id: 0,
    design_id: 0,
    style: ''
  };
  sizeRes: any;
  setFull: any;
   setHalf: any;
  sizeList: any;
  damList: any;
  materialList: any;
  desList: any = {
    shirt_design_no : '',
    style: '',
    type: '',
    mrp: '',
    wo_no : '',
    rgrn_no: '',
    rgrn_date: '',
    rgrn_pcs : 0,

  }
  count: number = 0;
  fsTot: number = 0;
  hsTot: number = 0;
  qualityList: any;
  typeList: any;
  coreList: any;
  shadeIndex: number = 0;
  onsaveDisable: boolean = true;
  gangList: any;
  coredesignList: any;
  gangdesignList: any;
  shadeTypeList: any = [];
  shadeTypeListExists: any = [];
  purchaseAgentList = [];
  seasonList = [];
  designColors: any = [];

  // Draft related properties
  isDraftAvailable: boolean = false;
  isDraftLoaded: boolean = false;
  private DRAFT_KEY = 'bagging_draft_data';

  totalFields = {
  field1: 'Value 1',
  field2: 'Value 2454',
  field3: 'Value 3',
  field4: 'Value 4',
  field5: 'Value 5',
  field6: 'Value 6',
  field7: 'Value 7',
  field8: 'Value 83232',
  field9: 'Value 9',
  field10: 'Value Rnfhgf',
};
allKeys = Object.keys(this.totalFields);
firstFiveKeys = this.allKeys.slice(0, 4);
lastFiveKeys = this.allKeys.slice(4, 8);

  detailList: any = [];
  categoryData: any = [];
  saveDetect: boolean = false
  bag_data : any = {
  
  }
  filter: any = {
    season: "",
    date: "",
    ref_no: "",
    combo_name: "",
    shirt_no: "",
    bag_barcode: "",
    rgrn_no: "",
    fset_tot:0,
    hset_tot: 0,
     set_tot: 0
    // dhoti_no: "",
    // style: "",
    // variety: "",
    // dp_shirt: 0,
    // dp_dhoti: 0,
    // margin: 0,
    // combo_mrp: 0,
    // fs_rate: 0,
    // hs_rate: 0,
    // category: ""
  };

  designnoList = [];

  setData = [];
  combinedSet = [];
  shirtBarcodeDetails = [];

  comboDetails = [];
  barcodeDisabled = false;


  shadeType = "";
  shadeColor = "";
  widthList: any[];
  // designTypeList = ["NEW", "CORE", "GANG"];
  // desData: any = {
  //   totalmtr: 0,
  //   totalamt: 0,
  // };
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    // this.saveEvent = val["data"].tabevent;
    // let designdata = Object.assign({}, val["data"]);

    // if (this.mode == "Edit" || this.mode == "View") {
    //   this.filter = designdata;
    //   this.filter.date = designdata.ref_date;
    //   this.setMainDetails(this.filter)
    //   this.getComboStockDetails();
    // }
  }

  get params(): any[] {
    return this._params;
  }



  tempData = [];

  @Output() tabUpdateEvent = new EventEmitter();
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  filteredOptions: Observable<string[]>;
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private costservice: CostService,
    private sampService: SampleService,
    private comboservice: ComboService,
    private rgrnService : rgrnService
  ) { }
  
  ngOnInit() {
      this.filter.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.checkDraftAvailability();
      this.tableScroll();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  
  // Draft related methods
  checkDraftAvailability() {
    try {
      const draftData = localStorage.getItem(this.DRAFT_KEY);
      this.isDraftAvailable = !!draftData;
    } catch (error) {
      console.error('Error checking draft availability:', error);
      this.isDraftAvailable = false;
    }
  }

  saveToDraft() {
    try {
      const draftData = {
        filter: this.filter,
        temp: this.temp,
        count: this.count,
        fsTot: this.fsTot,
        hsTot: this.hsTot,
        onsaveDisable: this.onsaveDisable,
        shadeIndex: this.shadeIndex,
        bag_data: this.bag_data,
        setData: this.setData,
        combinedSet: this.combinedSet,
        shirtBarcodeDetails: this.shirtBarcodeDetails,
        barcodeDisabled: this.barcodeDisabled,
        shadeType: this.shadeType,
        shadeColor: this.shadeColor,
        // Additional data arrays
        sizeRes: this.sizeRes,
        setFull: this.setFull,
        setHalf: this.setHalf,
        sizeList: this.sizeList,
        damList: this.damList,
        materialList: this.materialList,
        desList: this.desList,
        designnoList: this.designnoList,
        comboDetails: this.comboDetails,
        detailList: this.detailList,
        categoryData: this.categoryData,
        saveDetect: this.saveDetect,
        tempData: this.tempData,
        // Meta information
        draftSavedAt: new Date().toISOString(),
        mode: this.mode
      };

      localStorage.setItem(this.DRAFT_KEY, JSON.stringify(draftData));
      
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "success",
        title: "SUCCESS",
        body: "Draft saved successfully",
      });
      
      this.isDraftAvailable = true;
    } catch (error) {
      console.error('Error saving draft:', error);
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "ERROR",
        body: "Failed to save draft",
      });
    }
  }

  loadFromDraft() {
    try {
      const draftDataString = localStorage.getItem(this.DRAFT_KEY);
      if (!draftDataString) {
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "warning",
          title: "WARNING",
          body: "No draft data found",
        });
        return;
      }

      const draftData = JSON.parse(draftDataString);

      // Restore all the component state
      this.filter = draftData.filter || {};
      this.temp = draftData.temp || { set: '', id: 0, design_id: 0, style: '' };
      this.count = draftData.count || 0;
      this.fsTot = draftData.fsTot || 0;
      this.hsTot = draftData.hsTot || 0;
      this.onsaveDisable = draftData.onsaveDisable !== undefined ? draftData.onsaveDisable : true;
      this.shadeIndex = draftData.shadeIndex || 0;
      this.bag_data = draftData.bag_data || {};
      this.setData = draftData.setData || [];
      this.combinedSet = draftData.combinedSet || [];
      this.shirtBarcodeDetails = draftData.shirtBarcodeDetails || [];
      this.barcodeDisabled = draftData.barcodeDisabled || false;
      this.shadeType = draftData.shadeType || "";
      this.shadeColor = draftData.shadeColor || "";
      
      // Restore additional data arrays
      this.sizeRes = draftData.sizeRes;
      this.setFull = draftData.setFull;
      this.setHalf = draftData.setHalf;
      this.sizeList = draftData.sizeList;
      this.damList = draftData.damList;
      this.materialList = draftData.materialList;
      this.desList = draftData.desList || {
        shirt_design_no: '',
        style: '',
        type: '',
        mrp: '',
        wo_no: '',
        rgrn_no: '',
        rgrn_date: '',
        rgrn_pcs: 0,
      };
      this.designnoList = draftData.designnoList || [];
      this.comboDetails = draftData.comboDetails || [];
      this.detailList = draftData.detailList || [];
      this.categoryData = draftData.categoryData || [];
      this.saveDetect = draftData.saveDetect || false;
      this.tempData = draftData.tempData || [];

      this.isDraftLoaded = true;
      
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "success",
        title: "SUCCESS",
        body: `Draft loaded successfully (Saved at: ${new Date(draftData.draftSavedAt).toLocaleString()})`,
      });

    } catch (error) {
      console.error('Error loading draft:', error);
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "ERROR",
        body: "Failed to load draft data",
      });
    }
  }

  clearDraft() {
    swal({
      title: "Are you sure?",
      text: "This will permanently delete the saved draft data!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(() => {
      try {
        localStorage.removeItem(this.DRAFT_KEY);
        this.isDraftAvailable = false;
        this.isDraftLoaded = false;
        
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "success",
          title: "SUCCESS",
          body: "Draft cleared successfully",
        });
      } catch (error) {
        console.error('Error clearing draft:', error);
        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "ERROR",
          body: "Failed to clear draft",
        });
      }
    });
  }
  
  tableScroll() {
    $(".purreturn").height(window.innerHeight - 60);
    $(".pobody").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }



  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSeason(params).then((res: any) => {
      let partialSeason = [];

      for (let i = res.length - 1; i > res.length - 10; i--) {
        partialSeason.push(res[i]);
      }

      let today = new Date();
      let curDate =
        today.getFullYear() +
        "-0" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();

      res.forEach((el) => {
        if (curDate >= el.order_from && curDate <= el.order_to) {
          this.filter.season = el.season;
        }
      });

      this.seasonList = partialSeason;
    });
  }



    checkSave(){
      this.fsTot = 0;
      this.hsTot = 0;
      this.onsaveDisable = true;

      this.setData.forEach(el => {
        const count = Number(el.count) || 0;
        el.size.startsWith('F') ? this.fsTot += count : this.hsTot += count;
    
      });
       
      
      console.log("check save Enableeeee", this.shirtBarcodeDetails.length, this.fsTot, this.filter.set_tot)
      //For Handling Save Flag
      if (this.shirtBarcodeDetails.length == (this.fsTot + this.hsTot) && (this.fsTot + this.hsTot) == this.filter.set_tot) {

        this.onsaveDisable = false;
      }
    



    }
  getworkOrder() {
    let params = {
      wo_no: this.filter.rgrn_no,
      page: 'Bagging'
    };

    let that = this;
    that.rgrnService.getworkOrder(params).then((res: any) => {

      if (res.success) {
        this.filter.fset_tot = res.data.ftot;
        this.filter.hset_tot = res.data.htot;
        this.filter.set_tot  = res.data.ftot + res.data.htot;
        this.filter.rgrn_id = res.data.rgrn_id;
        this.barcodeFocus('shirtBarcode');
        this.getsetSIzeDet();
      }
      else {
        this.errorSwal(res.message);
        this.filter.rgrn_no = '';
      }

    });
  }

  getsetSIzeDet() {
    let params = {
      setSize_id: this.filter.rgrn_id,
      page: 'Bagging'
    };

    let that = this;
    that.rgrnService.getworkOrder(params).then((res: any) => {

      if (res.success) {
         that.setFull = res.setFull;
         that.setHalf = res.setHalf;
         that.sizeList = res.sizeList;
         that.desList = res.desList;
         that.damList = res.damList;
         that.materialList = res.materialList;
         that.combinedSet = res.combinedSet
        if (this.combinedSet.length > 0) {
          that.combinedSet.forEach(entry => {
            const matchedMaterial = that.materialList.find(mat => mat.capacity === entry.set_per);
            if (matchedMaterial) {
              entry.item = matchedMaterial.prefix;
            }
            entry.bal = entry.setCount - entry.scanned;
          });
        }
        console.log("check set Materialsssss", this.combinedSet)
        that.calculateMaterials();
      }
      else {
        // this.errorSwal(res.message);
        // this.filter.rgrn_no = '';
      }

    });
  }

  loadModel(){
      $("#designpr").modal("show");
  }

  closeModel(){
         $("#designpr").modal("hide");
  }

  getBarcodeDetails(flag: string, event: any) {
    this.onsaveDisable = true;
    if (!this.filter.bag_barcode) {
      this.errorSwal("Please Scan Bag.Barcode First!!");
      event.target.value = '';
      this.barcodeFocus('bag_barcode');
      return;
    }
    let setsizeExist = false;
    const params = {
      barcode: event.target.value,
      page_from: 'Bagging'
    }
    if (flag == "shirtBarcode") {
      if (params.barcode.length == 7) {
        const isExist = this.shirtBarcodeDetails.find((data) => data.barcode == params.barcode);
        if (!isExist) {
          this.barcodeDisabled = true;
          this.sampService.getShirtbarcodeDet(params).then((res: any) => {
            if (res.success && res.data) {
              res.data['bag_barcode'] = this.bag_data.bag_barcode
               res.data['bag_id'] = this.bag_data.bag_id
              // this.shirtBarcodeDetails.push(res.data);
              if(!this.filter.rgrn_no){
                 this.filter.rgrn_no = res.data.rgrn_no;
                  this.getworkOrder();     
              }

              if(this.filter.rgrn_id && (res.data.rgrn_id !== this.filter.rgrn_id)){
                
                swal("ERROR", `It's a Different Rgrn Item Barcode!!`, "error")
              }
              else if (((this.temp.id == res.data.set_id) || !this.temp.id) && (this.temp.design_id == res.data.design_id) || !this.temp.design_id) {

                // temp.set.set_name = { set_name: res.data.set_name };
                if (!this.temp.id && !this.temp.design_id) {
            
                  this.sizeRes = [];
                  this.temp.set = res.data.set_name;
                  this.temp.id = res.data.set_id;
                  this.temp.design_id = res.data.design_id
                  this.temp.style = res.data.style.toLowerCase();
                  const [start, end] = this.temp.set.split("-").map(Number);


                  for (let i = start; i <= end; i++) {
                    if (i % 2 === 0) {
                      this.sizeRes.push(i.toString());
                    }
                  }

                }
                if (this.shirtBarcodeDetails.find(x => x.bag_barcode.trim() == this.bag_data.bag_barcode && x.size.trim() == res.data.size)) {
                  setsizeExist = true;
             
                  swal("ERROR", `${res.data.size} Already Exist this Bag!!`, "error")
                  // this.shirtBarcodeDetails.splice(this.shirtBarcodeDetails.length-1, 1)
                }

                if (!setsizeExist) {

                  if (this.sizeRes.includes(res.data.size.split('').filter(char => !isNaN(char)).join(''))) {
          
                    this.count = this.count + 1;

                     //Check capacity with scanned set pcs Count
                      if (this.temp.style && this.temp.style in this.bag_data) {

                        // key exists in bag_data
                        const value = this.bag_data[this.temp.style];


                      if(this.sizeRes.length !== value){
                         this.count = this.count - 1;
                        this.temp.set = '';
                        this.temp.id = 0;
                        this.temp.design_id = 0;
                        this.temp.style = '';
                        console.log("bag Count check","set", this.sizeRes.length, this.temp.style, value, this.count)
                        swal("ERROR", `Pls Scan Count- ${value} Matching Set!!`, "error") 
                           this.barcodeDisabled = false;
                        this.barcodeFocus('shirtBarcode');
                         return
                      }
                       else if (this.count > value) {

                          swal("ERROR", `Bag Capacity (${value}) Reached Can't Scan!!`, "error")
                           this.count = this.count - 1;
                           this.barcodeDisabled = false;
                          this.barcodeFocus('shirtBarcode');
                           return
                        }
                      }

          
                  }
                  
              
                  if (this.count == this.sizeRes.length) {
        
                    // Determine the target array based on the condition
                    // const targetArray = res.data.size.charAt(0) === 'F' ? this.setData : this.hsetData;

                    // Push the data into the dynamically selected array
                    this.setData.push({
                      set_name: res.data.set_name,
                      count: this.count,
                      bag_barcode: this.bag_data.bag_barcode,
                      set_id: res.data.set_id,
                      size: res.data.size.charAt(0) === 'F' ? 'F/S' : 'H/S',
                      shade: res.data.shade
                    });
                    console.log(this.setData, this.combinedSet, "cehcjk After Pushhhhhhhh....")
                    console.log("check target Array", this.setData)
                    let setObj = this.setData[this.setData.length-1]
                    this.combinedSet.forEach(item => {
                      if (
                        item.setName == setObj.set_name && item.set_type === setObj.size && item.shade == setObj.shade
                      ) {
                        item.scanned += 1;
                        item.bal = item.setCount - item.scanned;
                        item.isBackground = item.bal > 0;
                        item.isCompleted = (item.setCount == item.scanned)
                      }
                    });
                    // this.barcodeFocus('bag_barcode');
                    this.temp.set = '';
                    this.temp.id = 0;
                    this.count = 0;
                    this.temp.design_id = 0;
                    this.temp.style = '';
                    this.filter.bag_barcode = '';
                    this.bag_data = {};
                    flag = 'bag_barcode';

                    this.shirtBarcodeDetails = this.shirtBarcodeDetails.map((item) => ({
                      ...item,
                      isBackground: false,
                    }));

                  }
                  // this.shirtBarcodeDetails.push(res.data);
                  res.data['isBackground'] = this.count > 0;
                  this.shirtBarcodeDetails.unshift(res.data);
                  this.checkSave();
                  //  this.temp.set = '';
                  //  this.barcodeFocus('bag_barcode');
                }

              }
              //Scan If the same size but different set Name
              else if ((this.temp.id !== res.data.set_id) && this.temp.id) {
          
                swal("ERROR", `${res.data.set_name} Is Different Set!!`, "error")

              }
              //Scan If  different Shade/Design
              else if ((this.temp.design_id !== res.data.design_id) && this.temp.design_id) {
        
                swal("ERROR", ` ${res.data.design_no}- Is Different Design/Shade Pcs!!`, "error")

              }
     
            } else {
              this.errorSwal(res.message);
            }
            this.barcodeDisabled = false;
            this.barcodeFocus(flag);
          });
        } else {
         this.barcodeDisabled = false;
          this.errorSwal("Barcode already exist");
          this.checkSave();
        }
        event.target.value = "";

   
      }
    }
  }

  calculateMaterials() {

    // Step 1: Combine setFull and setHalf by setName + set_per
    const combinedMap = new Map();

    [...this.setFull, ...this.setHalf].forEach(item => {
      const key = `${item.setName}__${item.set_per}`;
      if (!combinedMap.has(key)) {
        combinedMap.set(key, {
          setName: item.setName,
          set_per: item.set_per,
          count: 0
        });
      }
      combinedMap.get(key).count += item.setCount;
    });

    const combinedSets = Array.from(combinedMap.values());

    // Step 2: Initialize materialList with needed = 0
    const result = this.materialList.map(mat => ({
      ...mat,
      needed: 0
    }));

    // Step 3: For each set, find matching material by capacity == set_per
    combinedSets.forEach(set => {
      const matchingMaterial = result.find(m => m.capacity === set.set_per);
      if (matchingMaterial) {
        matchingMaterial.needed += set.count;
      }
    });

    // Final Output
    this.materialList = result.filter(m => m.needed > 0)
    console.log(this.materialList, "material needed::::");
  }
  getBagBarcodeDetails(flag: string, event: any) {

    const params = {
      bag_barcode: this.filter.bag_barcode,
    }



    if (this.filter.bag_barcode.length != 8) {

   

      const [prefix, number] = this.filter.bag_barcode.split('-');

      const requiredLength = 8;
      const dashLength = 1;
      const prefixLength = prefix.length;
      const paddedNumberLength = requiredLength - prefixLength - dashLength;

      // Pad the number with leading zeros
      const paddedNumber = number.padStart(paddedNumberLength, '0');

      // Final barcode
      this.filter.bag_barcode = `${prefix}-${paddedNumber}`;


    }
   


      // Split into prefix and padded number
      let [prefix, paddedNumber] = params.bag_barcode.split('-');

      // Remove leading zeros
      let originalNumber = paddedNumber.replace(/^0+/, '');

      // Handle case like 'B3-000000' → 'B3-0'
      if (originalNumber === '') {
        originalNumber = '0';
      }

      // Combine back to short format
      let shortCode = `${prefix}-${originalNumber}`;

      const isExist = this.shirtBarcodeDetails.find((data) => data.bag_barcode == shortCode);
      if (!isExist) {

        this.sampService.getShirtbarcodeDet(params).then((res: any) => {
          if (res.success && res.bagData) {

            this.bag_data = res.bagData
            this.filter.bag_barcode = this.bag_data.bag_barcode
            this.barcodeFocus('shirtBarcode');
          } else {
            this.errorSwal(res.message);
            this.filter.bag_barcode = '';
            this.barcodeFocus('bag_barcode');
          }


        });
      } else {
        this.errorSwal("Bag Barcode already exist");
        this.filter.bag_barcode = '';
        this.barcodeFocus(flag);
      }
    

  }

  errorSwal(message: string) {
    swal({
      type: "error",
      titleText: message,
      showCancelButton: false,
      showConfirmButton: false,
      timer: 2000
    });
  }

  barcodeFocus(id: string) {
    setTimeout(() => {
      document.getElementById(id).focus();
    }, 300);
  }



  deleteRow(flag: string, index: number) {
   
   //If delete the completed set Name Barcode, then delete all of remaining barcodes as well

   //Runnig set delete check 
    this.shirtBarcodeDetails
      .filter(e => e.bag_barcode === this.shirtBarcodeDetails[index].bag_barcode)
      .forEach(e => e.isBackground = true);
    if (this.temp.id > 0) {
      this.shirtBarcodeDetails.splice(index, 1);
      this.count = this.count - 1
    }
    //Completed Set delete check
    else if (!this.temp.set) {

      // const targetArray = this.shirtBarcodeDetails[index].size.charAt(0) === 'F' ? this.setData : this.hsetData;
      const filteredItems = this.setData.filter(e => e.bag_barcode === this.shirtBarcodeDetails[index].bag_barcode);
     if (filteredItems.length > 0) {

        const lastIndex = this.setData.lastIndexOf(filteredItems[filteredItems.length - 1]);

         let setObj = this.setData[lastIndex]
        this.setData.splice(lastIndex, 1);
       this.combinedSet.forEach(item => {
         if (
           item.setName == setObj.set_name && item.set_type === setObj.size && item.shade == setObj.shade && item.scanned > 0
         ) {
           item.scanned -= 1;
           item.bal += 1
           item.isBackground = item.bal > 0;
           item.isCompleted = (item.setCount == item.scanned)
         }
       });

      }
      this.shirtBarcodeDetails.splice(index, 1);
    }
    this.checkSave();
    // else {
    //   this.shirtBarcodeDetails.splice(index, 1);
    // }

  }

  addDStock() {

      this.filter.date = this.datePipe.transform(this.filter.date, "yyyy-MM-dd");
      let that = this;
      let params: any = Object.assign({}, this.filter);
      params["tabevent"] = undefined;
      params["shirtDetails"] = JSON.stringify(this.shirtBarcodeDetails);

      params['page_from'] = 'bagging';

      swal({
        title: "Are you sure to save this Stock?",
        type: "info",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.sampService.addBaggingStock(params).then(function (res: any) {
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: "Bag No added successfully",
            });
            
            // Clear draft after successful save
            that.clearDraftSilently();
            
            that.filter.bag_barcode = '';
            that.shirtBarcodeDetails = [];
            that.setData = [];
            // that.hsetData = [];
            that.combinedSet = [];
            that.onsaveDisable = true;
            that.filter.rgrn_no='';
            that.filter.rgrn_id = 0;
            that.filter.fset_tot = 0;
            that.filter.hset_tot = 0;
            that.filter.set_tot = 0;
            that.fsTot =0;
            that.hsTot = 0;

            // let tabObj = {
            //   action: "CloseTab",
            //   params: {},
            // };
            // that.tabUpdateEvent.emit(tabObj);
            // that.saveEvent.emit(tabObj);
          } else {
            swal("ERROR", res.message, "error");
          }
        });
      });
  
  }

  // Helper method to clear draft without showing notification
  private clearDraftSilently() {
    try {
      localStorage.removeItem(this.DRAFT_KEY);
      this.isDraftAvailable = false;
      this.isDraftLoaded = false;
    } catch (error) {
      console.error('Error clearing draft silently:', error);
    }
  }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/AddEditbagging.ts